import styles from './index.module.less';
import { Space, Image, Row, Col } from 'antd'; //, Card

import { numFormating } from 'utilities/helpers';
import LocalStorage from 'utilities/localStorage';

import approvedIcon from '../../../../welcome/image/approvedIcon.svg';

import { sizeChecker } from 'utilities/helpers';
import { useNavigate } from 'react-router-dom';

export default function CardStatus1({
  acceptedCount,
  giftsGiven,
  giftsReceived,
  numberOfRequests
}) {
  const navigate = useNavigate();
  const isMobile = sizeChecker('xs');

  const handleReDirect = (stutus) => {
    // console.log('stutus', stutus);
    LocalStorage.setItem('dashboardCard_status', JSON.stringify(stutus));
  };
  const handleReDirectReceivedGifts = (stutus) => {
    // console.log('stutus', stutus);
    LocalStorage.setItem(
      'dashboardCard_ReceivedGifts_status',
      JSON.stringify(stutus)
    );
  };
  const handleCardClick = (item) => {
    // console.log('item', item);
    if (item?.id === 1) {
      handleReDirect('ACCEPTED');
      navigate('/adminDashboard-giftGiven-link');
    } else if (item?.id === 2) {
      handleReDirect('');
      navigate('/adminDashboard-giftGiven-link');
    } else if (item?.id === 3) {
      // GIFTS RECEIVED card
      handleReDirectReceivedGifts('');
      LocalStorage.setItem(
        'adminGiftsReceived_navigation',
        JSON.stringify(true)
      );
      navigate('/adminDashboard-giftReceived-link', {
        state: { adminGiftsReceived: 'adminGiftsReceived' }
      });
    }
  };
  const cardContent = [
    {
      id: 1,
      title: (
        <a
          className={`${styles.cardLink_title}`}
          // href="/adminDashboard-giftGiven-link"
          // onClick={() => handleReDirect('ACCEPTED')}
        >
          {' '}
          ACCEPTED
        </a>
      ), //'acceptedCount',
      value: acceptedCount,
      icon: (
        <a
        // href="/adminDashboard-giftGiven-link"
        // onClick={() => handleReDirect('ACCEPTED')}
        >
          <Image
            className={`${styles.gift_icon_size}`}
            alt="approvedIcon"
            src={approvedIcon}
            preview={false}
          />
        </a>
      )
    },
    {
      id: 2,
      title: (
        <a
          className={`${styles.cardLink_title}`}
          // href="/adminDashboard-giftGiven-link"
          // onClick={() => handleReDirect('')}
        >
          GIFTS GIVEN
        </a>
      ), //'giftsGiven',
      value: giftsGiven,
      icon: (
        <a
        // href="/adminDashboard-giftGiven-link"
        // onClick={() => handleReDirect('ACCEPTED')}
        >
          <Image
            className={`${styles.gift_icon_size}`}
            alt="approvedIcon"
            src={approvedIcon}
            preview={false}
          />
        </a>
      )
    },
    {
      id: 3,
      title: <a className={`${styles.cardLink_title}`}>GIFTS RECEIVED</a>, //giftsReceived',
      value: giftsReceived,
      icon: (
        <a>
          <Image
            className={`${styles.gift_icon_size}`}
            alt="approvedIcon"
            src={approvedIcon}
            preview={false}
          />
        </a>
      )
    },

    {
      id: 4,
      title: 'TOTAL REQUESTS', //'numberOfRequests',
      value: numberOfRequests,
      icon: (
        <a href="">
          <Image
            className={`${styles.gift_icon_size}`}
            alt="approvedIcon"
            src={approvedIcon}
            preview={false}
          />
        </a>
      )
    }
  ];
  return (
    <div>
      <div className={`${styles.card_container} mb-3 `}>
        <Space
          className={`${styles.card_space_between}`}
          direction={isMobile ? 'vertical' : 'horizontal'}
          size="middle"
          gap={26}
          style={{
            display: 'flex',
            justifyContent: 'space-between'
          }}
        >
          {cardContent?.map((item, index) => (
            <div
              key={index}
              className={`${styles.card_content_style}`}
              onClick={() => handleCardClick(item)}
              style={
                item?.id === 1 || item?.id === 2 || item?.id === 3
                  ? { cursor: 'pointer' }
                  : {}
              }
              //style={{ cursor: 'pointer' }}
            >
              <Row
                style={{
                  height: '35px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center'
                }}
              >
                <Col>
                  <div className={`${styles.card_icon_div}`}>
                    <span className={`${styles.card_icon_style}`}>
                      {item?.icon}
                    </span>
                  </div>
                </Col>
                <Col>
                  <span className={`${styles.card_title_style}`}>
                    {item?.title}
                  </span>
                </Col>
              </Row>
              <Row className={`${styles.card_amount_style}`}>
                {numFormating(item?.value)}
              </Row>
            </div>
          ))}
        </Space>
      </div>
    </div>
  );
}
